mutation UpdateMediaFiles($clientId: ID!, $folderId: ID!, $files: [InputMediaFileUpdate]!) {
    updateMediaFiles(clientId: $clientId, folderId: $folderId, files: $files) {
        id
    }
}
